import { observer } from 'mobx-react';
import { autoinject, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AccountStore } from './AccountStore';

export interface ILoginProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class LoginView extends React.Component<ILoginProps> {
    public componentDidMount() {
        this.accountStore.signinRedirect(this.props.location.state);
    }

    public render() {
        return <div>Logging in...</div>;
    }

    @inject
    private accountStore!: AccountStore;
}
